/** Shared layout / FLIP spring — snappy enough for drag previews, no cartoon bounce. */
export const layoutSpring = {
  type: "spring" as const,
  stiffness: 400,
  damping: 30,
};

export const modalListAnimation = {
  container: {
    show: {
      // opacity: 1,
      transition: {
        staggerChildren: 0.04,
      },
    },
  },
  item: {
    hidden: {
      y: 50,
      opacity: 0,
      transition: {
        y: { stiffness: 1000 },
      },
    },
    show: {
      y: 0,
      opacity: 1,
      transition: {
        y: { stiffness: 1000, velocity: -100 },
      },
    },
  },
};

export {
  cascadeEnter,
  cascadeRevealDelay,
  prefersReducedMotion,
} from "./cascadeReveal";
